"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Box extends Component {

    static defaultProps = {

    };

    static propTypes = {
        icon: PropTypes.string ,
        header: PropTypes.string,
        content: PropTypes.oneOfType([
                     PropTypes.arrayOf(PropTypes.node),
                     PropTypes.node
                 ]),
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { icon, header, content } = this.props;
        return (
            <div className="box box-solid">
                {this.renderBoxHeader(icon, header)}
                {this.renderBoxContent(content)}
            </div>
        );
    }

    renderBoxHeader(icon, header) {
        return header || icon
               ? <div className="box-header with-border">
                     <i className="fa">{icon ? <FontAwesomeIcon icon={icon} /> : null}</i>
                     {header ? <h3 className="box-title">{header}</h3> : null}
                 </div>
               : null;
    }

    renderBoxContent(content) {
        return content
               ? <div className="box-body">
                     {content}
                 </div>
               : null;
    }
}

export default Box;